import { Button, Card, CardActions, CardContent, Dialog, DialogContent, DialogTitle, TextField } from '@mui/material'
import { Link } from 'react-router-dom';
import { countriesService } from 'services/countries.service';
import _ from 'lodash'
import { HajjImage } from 'components/HajjImage/HajjImage';
import { snack } from 'components/Snack/Snack';
import offersSAService from 'services/superadmin/offersSAService';
import { OfferStatus } from 'components/OfferStatus';

export default function ProductCardSuperAdmin({ offer, options, loadData }) {
    const product = offer.product;
    const hideButtons = _.get(options, 'hideButtons')

    const hideOffer = async () => {
        try {
            const isConfirmed = window.confirm('Вы точно хотите снять с прожади товар?')

            if (isConfirmed) {
                await offersSAService.hide(offer.id);
                snack('Товар успешно снят с продажи!')
                loadData && loadData()
            }
        } catch (ex) {
            console.error('При снятии с продажи товара вышла ошибка:', ex?.message)
        }
    };

    const publishOffer = async (offer) => {
        await offersSAService.publish(offer.id, {
            status: "AVAILABLE"
        });
        snack('Товар успешно опубликован!')
        loadData && loadData()
    }

    return (
        <div>
            <Card className='p-16'>
                <CardContent>
                    <div className='flex gap-16'>
                        <div style={{ borderRadius: '8px', overflow: 'hidden', flex: 0.10 }}>
                            <HajjImage image={product.photo} />
                        </div>
                        <div className='profile' style={{ flex: 1 }}>
                            <h3>{product.name}</h3>
                            <div className='m-t-8'>Цена: {offer.price} {offer.currency}</div>
                            <div className='m-t-8'>Остатки: {offer.stock} шт.</div>
                            <div className='m-t-8'>Наличие в магазинах: {offer.salePoint?.name} (г. {offer.salePoint?.city?.name})</div>
                            <h5 className='m-t-8'>{product.category?.name}</h5>
                            <div className='m-t-8'>{countriesService.getAll(product.country)?.name}</div>
                            <div className='m-t-8'>{product.city?.name}</div>
                            <div className='m-t-8'>{product.address}</div>
                            {product.website ? <div className='m-t-8'>
                                <a href={product.website} className='color-blue' rel="noreferrer" target="_blank">{product.website}</a>
                            </div> : <></>}
                        </div>
                        <div className='m-b-8 color-gray m-l-auto' style={{ marginLeft: 'auto', width: 'fit-content' }}>
                            <div>Код товара: {product.id}</div>
                            <div>Код предложения: {offer.id}</div>                            
                            <OfferStatus status={offer.status} />
                        </div>
                    </div>
                </CardContent>
                {hideButtons ? <></> : <CardActions className='justify-end'>
                    <Link onClick={() => publishOffer(offer)}>
                        <Button size="small">Опубликовать</Button>
                    </Link>
                    <Link onClick={() => hideOffer(offer)}>
                        <Button size="small">Снять с продажи</Button>
                    </Link>
                </CardActions>}
            </Card>
        </div>
    )
}
